import Divider from '@/components/ui/divider';
import { withStaticProps } from '@/server/app';
import ContactForm from '@components/common/form/contact-form';
import Container from '@components/ui/container';
import ContactInfoBlock from '@containers/contact-info';
import { useTranslation } from 'next-i18next';

export default function ContactUsPage() {
  const { t } = useTranslation('common');
  return (
    <>
      <Divider className="mb-0" />
      <Container>
        <div className="my-14 mx-auto flex w-full flex-col px-0 pb-2 md:flex-row lg:my-16 xl:my-20 xl:max-w-screen-xl">
          <div className="flex h-full flex-col md:w-full lg:w-2/5 2xl:w-2/6">
            <ContactInfoBlock />
          </div>
          <div className="flex h-full flex-col md:w-full md:ms-7 lg:w-3/5 lg:ps-7 2xl:w-4/6">
            <div className="mt-7 flex pb-7 md:-mt-1.5 md:pb-9">
              <h4 className="text-2xl font-bold text-heading 2xl:text-3xl">{t('text-get-in-touch')}</h4>
            </div>
            <ContactForm />
          </div>
        </div>
      </Container>
    </>
  );
}

export const getStaticProps = withStaticProps();
